import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, useMediaQuery } from '@mui/material';
import ReactHtmlParser from 'react-html-parser';
import { reduceFontSizePxInHtml } from 'common/utils';
import theme from 'theme';

const DynamicStripSection = ({ dynamicText, dynamicTextImage }) => {    
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const processedDynamicText = isMobile ? reduceFontSizePxInHtml(dynamicText, 4) : dynamicText;
    return (
        <Box
            sx={{
                backgroundImage: `url(${dynamicTextImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: '#fffff',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingLeft: { xs: '10px' },
                paddingRight: { xs: '10px' },
            }}
            testID="dynamic-strip-section"
        >
            <Typography style={{
                textAlign: 'center',
            }}>
                {ReactHtmlParser(processedDynamicText)}
            </Typography>
        </Box>
    );
};

DynamicStripSection.propTypes = {
    dynamicText: PropTypes.string.isRequired,
    dynamicTextImage: PropTypes.string.isRequired,
};

export default DynamicStripSection; 